<template>
  <div class="feed-item">
    <div class="header-wrapper">
      <FeedHeader :feed="feed" :scene="feedScene" />
    </div>
    <div class="body-wrapper">
      <div class="feed-body">
        <div class="feed-title ellipsise">{{ initFeedTitle }}</div>
        <div class="feed-summary">{{ cutOutContent }}</div>
        <div class="link-wrapper">
          <a href="javascript:;" @click="viewDetail">查看详情</a>
        </div>
        <ArticleElement
          v-if="feed.article === FEED_TYPES.ARTICLE"
          :feed="feed"
          :scene="feedScene"
        />
        <AlbumElement
          v-if="feed.article === FEED_TYPES.ALBUM"
          :feed="feed"
          :scene="feedScene"
        />
        <AudioElement v-if="feed.article === FEED_TYPES.AUDIO" :feed="feed" />
        <VideoElement v-if="feed.article === FEED_TYPES.VIDEO" :feed="feed" />
      </div>
    </div>
    <div class="footer-wrapper">
      <FeedFooter :feed="feed" :scene="feedScene" />
    </div>
  </div>
</template>
<script>
import FeedHeader from "./feed-header";
import FeedFooter from "./feed-footer";
import ArticleElement from "./feed-elements/article-element";
import AlbumElement from "./feed-elements/album-element";
import AudioElement from "./feed-elements/audio-element";
import VideoElement from "./feed-elements/video-element";
import { sliceFeedContent, htmlFilter } from "../../utils/feed";
export default {
  name: "feed-item",
  data() {
    return {
      feedScene: "feedList",
    };
  },
  props: {
    feed: {
      type: Object,
      required: true,
    },
  },
  components: {
    FeedHeader,
    FeedFooter,
    ArticleElement,
    AlbumElement,
    AudioElement,
    VideoElement,
  },
  computed: {
    initFeedTitle() {
      return htmlFilter(this.feed.title);
    },
    cutOutContent() {
      return sliceFeedContent(this.feed.content);
    },
    initDetailLink() {
      return `/detail?feedID=${this.feed.modelId}&feedType=${this.feed.article}`;
    },
  },
  methods: {
    viewDetail() {
      // this.$router.push({
      //   path: "detail",
      //   query: { feedID: this.feed.modelId, feedType: this.feed.article },
      // });
      let routerClanCard = this.$router.resolve({
        path: "detail",
        query: { feedID: this.feed.modelId, feedType: this.feed.article },
      });
      window.open(routerClanCard.href, "_blank");
    },
  },
};
</script>
<style scoped>
.feed-item {
  margin-bottom: 15px;
  padding: 15px;
  background-color: #fff;
}

.feed-body {
  margin-left: 55px;
}

.feed-title {
  max-width: 450px;
  line-height: 30px;
  font-weight: bold;
  font-size: 16px;
}

.feed-summary {
  width: 700px;
  line-height: 25px;
  font-size: 16px;
  white-space: pre-wrap;
}

.link-wrapper a {
  color: #1a70db;
}
</style>